import { formatDate } from 'lib/helpers/dateUtils';

import Popover from 'components/shared/Popovers/Popover/Popover';

export const getTrainingsColumns = (onEditTraining, isAdmin, timezone) => [
  {
    field: 'name',
    headerName: 'Training name',
    flex: 1
  },
  {
    field: 'date',
    headerName: 'Date',
    flex: 1,
    valueGetter: ({ data }) => {
      const startsAt = data?.starts_at;
      const endsAt = data?.ends_at;

      if (!startsAt) return 'N/A';

      const datePart = formatDate(startsAt, timezone, 'MM/dd/yyyy');
      const startTime = formatDate(startsAt, timezone, 'h:mm a');
      const tzAbbrev = formatDate(startsAt, timezone, 'zzz');

      if (!datePart) return 'N/A';

      if (endsAt) {
        const endTime = formatDate(endsAt, timezone, 'h:mm a');
        if (endTime) return `${datePart} ${startTime} - ${endTime} ${tzAbbrev}`;
      }

      return `${datePart} ${startTime} ${tzAbbrev}`;
    }
  },
  ...(isAdmin
    ? [
        {
          field: 'actions',
          headerName: '',
          maxWidth: 80,
          pinned: 'right',
          cellRenderer: ({ data }) => (
            <div className="flex h-full items-center justify-center">
              <Popover
                isFixed
                options={[
                  {
                    label: 'Edit',
                    onClick: () => onEditTraining(data),
                    icon: 'edit-2-mono'
                  }
                ]}
                position="left"
                icon="context-menu-horizontal"
                className="flex flex-1 justify-center self-center"
              />
            </div>
          )
        }
      ]
    : [])
];
